import _ from 'lodash';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultForm = {
  blocks: [],
};

export default {
  actions: {
    async [actions.DO_CREATE_FORM]({ commit, dispatch }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.post(`/events/${id}/forms`, params);
      commit(mutations.SET_FORM, data.data.forms[0]);
      await dispatch(actions.DO_GET_EVENT, { id });
      return data;
    },
    async [actions.DO_GET_FORM]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/forms/${id}`, payload);
      commit(mutations.SET_FORM, data.data.forms[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_FORM]: state => state.form,
    [getters.GET_FORM_SAVING]: state => state.saving,
    [getters.GET_FORM_REFRESH]: state => state.refresh,
  },
  mutations: {
    [mutations.ADD_FORM_BLOCK_AT_INDEX](state, payload) {
      state.form.blocks.splice(payload.index, 0, payload.block);
    },
    [mutations.ADD_FORM_FIELD_FOR_BLOCK](state, payload) {
      const block = _.find(state.form.blocks, { id: payload.block_id });
      block.form_fields.splice(payload.index, 0, payload.field);
    },
    [mutations.MOVE_FORM_FIELD_FOR_BLOCK](state, payload) {
      const block = _.find(state.form.blocks, { id: payload.block_id });
      block.form_fields.splice(payload.to, 0, block.form_fields.splice(payload.from, 1)[0]);
    },
    [mutations.REMOVE_BLOCK_FROM_FORM](state, payload) {
      state.form.blocks.splice(payload.index, 0);
    },
    [mutations.REMOVE_FORM_FIELD_FOR_BLOCK](state, payload) {
      const block = _.find(state.form.blocks, { id: payload.block_id });
      block.form_fields.splice(payload.index, 1);
    },
    [mutations.SET_FORM](state, form) {
      state.form = form;
    },
    [mutations.SET_FORM_SAVING](state, saving) {
      state.saving = saving;
    },
    [mutations.SET_FORM_REFRESH](state, refresh) {
      state.refresh = refresh;
    },
    [mutations.SET_FIELD_FOR_BLOCK](state, field) {
      const nodes = field.key.split('.');
      let obj = _.find(state.form.blocks, { id: field.block_id });
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_FIELD_FOR_BLOCK_FIELD](state, field) {
      const nodes = field.key.split('.');
      const block = _.find(state.form.blocks, { id: field.block_id });
      let obj = field.field_id ? _.find(block.form_fields, { id: field.field_id }) : block.form_fields[field.field_index];
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
  },
  state: {
    form: Object.assign({}, defaultForm),
    saving: false,
    refresh: false,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/form.js